<script>
import baseMixin from '@/mixins/baseMixin'
import { TimesheetPrimaryGroupingType } from '@/shared/constants/timesheet/TimesheetPrimaryGroupingType'
import CustomTooltip from '@/components/booking/bookingList/custom-tooltip.vue'

export default {
  name: 'TimesheetPrimaryGroupingToggle',
  components: { CustomTooltip },
  mixins: [baseMixin],
  model: {
    prop: 'toggleValue',
    event: 'toggleUpdated',
  },
  props: {
    toggleValue: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      TimesheetPrimaryGroupingType,
    }
  },
  computed: {
    toggleValueModel: {
      get() {
        return this.toggleValue
      },
      set(value) {
        this.$emit('toggleUpdated', value)
      },
    },
  },
}
</script>

<template>
  <div class="timesheet-primary-grouping-toggle">
    <v-btn-toggle v-model="toggleValueModel" mandatory>
      <CustomTooltip
        position="bottom"
        :text="$t('timesheets.primaryGrouping.clientGroupingTooltip')"
      >
        <v-btn
          data-testid="timesheet-group-toggle-client"
          :value="TimesheetPrimaryGroupingType.client"
        >
          <span v-if="!isMobile">{{
            $t('timesheets.primaryGrouping.clientGroupingToggleText')
          }}</span>
          <v-icon v-else size="xs" color="grey darken-1" class="opacity-5"
            >mdi-bank</v-icon
          >
        </v-btn>
      </CustomTooltip>
      <CustomTooltip
        position="bottom"
        :text="$t('timesheets.primaryGrouping.candidateGroupingTooltip')"
      >
        <v-btn
          data-testid="timesheet-group-toggle-candidate"
          :value="TimesheetPrimaryGroupingType.candidate"
        >
          <span v-if="!isMobile">{{
            $t('timesheets.primaryGrouping.candidateGroupingToggleText')
          }}</span>
          <v-icon v-else size="xs" color="grey darken-1" class="opacity-5"
            >mdi-account</v-icon
          >
        </v-btn>
      </CustomTooltip>
    </v-btn-toggle>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/_colors.scss';
@import '@/styles/timesheet/timesheet-primary-grouping-toggle.scss';
</style>
